import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import CaseDetail from "./pages/CaseDetail";
import ArtigoCrushVirtual from "./pages/ArtigoCrushVirtual";
import VozisCase from "./pages/VozisCase";
import CaseVoicebotsOdonto from "./pages/CaseVoicebotsOdonto";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/case/:slug" element={<CaseDetail />} />
            <Route path="/artigo-crush-virtual" element={<ArtigoCrushVirtual />} />
            <Route path="/case-vozis" element={<VozisCase />} />
            <Route path="/case-voicebots-odonto" element={<CaseVoicebotsOdonto />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
